import React from 'react';

export function linkText(label) {
    return label.substring(
        label.lastIndexOf('{') + 1,
        label.lastIndexOf('}')
    );
}

export function labelStart(label) {
    return label.substring(
        label.lastIndexOf('{', 0),
        label.lastIndexOf('{')
    );
}

export function labelEnd(label) {
    return label.substring(
        label.lastIndexOf('}') + 1,
    );
}

export default function generateLabelLink(label, onClick, styles) {
    const optOutString = [
        `${labelStart(label)}`,
        <a
            className={styles}
            onClick={onClick}
        >
            {linkText(label)}
        </a>,
        `${labelEnd(label)}`
    ];
    return optOutString.map((stringPart, index) => {
        return typeof stringPart === 'string' ?
            <span dangerouslySetInnerHTML={{ __html: stringPart }} key={index} />
            :
            stringPart;
    });
}
